import request from '@/util/request';
import qs from 'qs';

export const getDataWarningList = (params, options) =>
request.get('/api/v4ward/energy/wsd/dataWarnings', Object.assign({}, options, { params }));

export const getDataMonitorList = (params, options) =>
request.get('/api/v4ward/energy/wsd/dataMonitor', Object.assign({}, options, { params }));